import { ReactElement } from "react";
import './squaredIcon.css';

interface SquaredIconProps {
    icon: ReactElement;
    onClick?: () => void;
}

export function SquaredIcon({ icon, onClick = () => {} }: SquaredIconProps) {
    return (
        <div className="squared-icon" onClick={() => onClick()}>
            {icon}
        </div>
    );
}